import script from "./Event.vue?vue&type=script&setup=true&lang=js"
export * from "./Event.vue?vue&type=script&setup=true&lang=js"

import "./Event.vue?vue&type=style&index=0&id=40cf6794&lang=scss&scoped=true"

import exportComponent from "/var/www/html/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-40cf6794"]])

export default __exports__